import React from 'react';
import {
  MaterialUICore,
  Body,
  InputAdornment,
  MaterialIcons,
  Select,
} from '@iclinic/design-system';

import { useConference } from 'features/video-conference/state/conferenceContext';
import { selectDevices } from 'features/video-conference/constants';
import useDevices from 'features/video-conference/hooks/useDevices';
import useStyles from '../styles';

const { MenuItem } = MaterialUICore;
const { VolumeUp } = MaterialIcons;

export default function AudioOutputList() {
  const classes = useStyles({});
  const { audioOutputDevices } = useDevices();
  const { activeSinkId, setActiveSinkId } = useConference();

  return (
    <div>
      {audioOutputDevices.length > 0 ? (
        <Select
          onChange={(e) => setActiveSinkId(e.target.value as string)}
          value={activeSinkId}
          data-testid="select"
          InputProps={{
            id: 'audio-input-list',
            startAdornment: (
              <InputAdornment position="start">
                <VolumeUp className={classes.iconColor} />
              </InputAdornment>
            ),
          }}
          label={selectDevices.AUDIO_OUTPUT}
        >
          {audioOutputDevices.map((device) => (
            <MenuItem value={device.deviceId} key={device.deviceId}>
              {device.label}
            </MenuItem>
          ))}
        </Select>
      ) : (
        <Body variant="xs" bold>
          {selectDevices.OUTPUT_DEFAULT}
        </Body>
      )}
    </div>
  );
}
